import { Button, Flex } from '@bamboohr/fabric';

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

const LoadMoreButton = ({ onClick, isLoading }: LoadMoreButtonProps) => {
  return (
    <Flex>
      <Button
        alignContent="left"
        variant="contained"
        color="secondary"
        size="small"
        onClick={onClick}
        disabled={isLoading}
        style={{ width: '100%', marginTop: 8 }}
      >
        {isLoading ? 'Scroll Down...' : 'Show More Chats'}
      </Button>
    </Flex>
  );
};

export default LoadMoreButton;
